module.exports = __webpack_public_path__ + "img/dl.58af8650.png";